import React, { useState } from 'react'
import { Box, Typography, Button, Stack, IconButton, Alert } from '@mui/material'
import FlashOnIcon from '@mui/icons-material/FlashOn'
import FlashOffIcon from '@mui/icons-material/FlashOff'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '../context/authcontext'
import { decryptData } from '../services/encryptionService'
import CameraScanner from '../components/scanner/CameraScanner'
import logoSplash from '../assets/logoSplash.png'

const QrCodeLoginView = () => {
  const { qrlogin } = useAuth()
  const navigate = useNavigate()
  const [error, setError] = useState(null)

  const handleScan = (result) => {
    try {
      const apiKey = decryptData(result.text)
      qrlogin(
        apiKey,
        () => navigate('/mode'),
        (message) => setError(message || "L'authentification a échoué")
      )
    } catch {
      setError("Ce code QR n'est pas un code de connexion valide")
    }
  }

  return (
    <Box
      sx={{
        position: 'relative',
        height: 'var(--app-vh)',
        width: '100%',
        overflow: 'hidden',
        bgcolor: '#06070A',
      }}
    >
      <CameraScanner onScan={handleScan}>
        {({ torch }) => (
          <>
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                pt: 'calc(var(--safe-top) + 10px)',
                pb: 3,
                pl: 'calc(var(--safe-left) + 8px)',
                pr: 'calc(var(--safe-right) + 16px)',
                background:
                  'linear-gradient(180deg, rgba(6,7,10,0.85) 0%, rgba(6,7,10,0) 100%)',
              }}
            >
              <IconButton
                onClick={() => navigate('/login')}
                aria-label="Retour"
                sx={{ color: '#FFFFFF' }}
              >
                <ArrowBackIcon fontSize="large" />
              </IconButton>
              <Box sx={{ flexGrow: 1 }} />
              <Box
                component="img"
                src={logoSplash}
                alt="TicketNGo"
                sx={{ height: 24, width: 'auto' }}
              />
            </Stack>

            <Stack
              spacing={2}
              alignItems="center"
              sx={{
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                pt: 6,
                pb: 'calc(var(--safe-bottom) + 16px)',
                pl: 'calc(var(--safe-left) + 16px)',
                pr: 'calc(var(--safe-right) + 16px)',
                background:
                  'linear-gradient(0deg, rgba(6,7,10,0.92) 0%, rgba(6,7,10,0) 100%)',
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: '#FFFFFF',
                  textAlign: 'center',
                  textShadow: '0 2px 12px rgba(0,0,0,0.6)',
                }}
              >
                Balayez le code QR d'authentification
              </Typography>

              {error ? (
                <Alert severity="error" variant="filled" sx={{ width: '100%', maxWidth: 420 }}>
                  {error}
                </Alert>
              ) : null}

              <Stack direction="row" spacing={1.5} sx={{ width: '100%', maxWidth: 420 }}>
                {torch.available ? (
                  <IconButton
                    onClick={torch.toggle}
                    aria-label="Torche"
                    aria-pressed={torch.isOn}
                    sx={{
                      width: 56,
                      height: 56,
                      flexShrink: 0,
                      color: torch.isOn ? '#0E0F11' : '#FFFFFF',
                      bgcolor: torch.isOn ? '#E84E1B' : 'rgba(255,255,255,0.14)',
                      border: '1px solid rgba(255,255,255,0.18)',
                    }}
                  >
                    {torch.isOn ? <FlashOnIcon /> : <FlashOffIcon />}
                  </IconButton>
                ) : null}
                <Button
                  fullWidth
                  variant="outlined"
                  size="large"
                  onClick={() => navigate('/login')}
                  sx={{
                    color: '#FFFFFF',
                    borderColor: 'rgba(255,255,255,0.35)',
                    '&:hover': { borderColor: '#FFFFFF', bgcolor: 'rgba(255,255,255,0.08)' },
                  }}
                >
                  Retour
                </Button>
              </Stack>
            </Stack>
          </>
        )}
      </CameraScanner>
    </Box>
  )
}

export default QrCodeLoginView
